import React from 'react'
import styled from 'styled-components'
import theme from '../../../styles/theme'
import SearchIcon from '../../../assets/image/search/ic-search.svg'

const SearchIconBtn = ({ onClick }) => {
  return (
    <IconBtnWrap>
      <button type="button" onClick={onClick}>
        <img src={SearchIcon} alt="찾기 아이콘" />
      </button>
    </IconBtnWrap>
  )
}

export default SearchIconBtn

const IconBtnWrap = styled.div`
  margin: 0;
  padding: 0;
  @media ${(props) => props.theme.mobile}, ${(props) => props.theme.tablet} {
    display: none;
  }
`
